import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrl: './photos.component.scss'
})
export class PhotosComponent implements OnInit {
  @Input() data: any;
  @Input() column: any;

  public count = 0 ;

  constructor() {}

  ngOnInit() {
    this.count = this.getPhotoCount(this.data);
  }

  getPhotoCount(data: any): number {
    let count = 0;

    // Group 1
    if (data.firstPhoto || data.photo1 || data.firstServicePhoto) {
      count++;
    }

    // Group 2
    if (data.secondPhoto || data.photo2 || data.secondServicePhoto) {
      count++;
    }

    // Group 3
    if (data.thirdServicePhoto) {
      count++;
    }

    return count;
  }
}
